import { Injectable } from '@angular/core';
import { BaseService, BaseServiceSZ } from '../other/baseService';
import { SharedService } from '../other/shared.service';
import * as signalR from '@microsoft/signalr';
import { MagicStrings } from '../../models/const/magic-strings';
import { Observable, Subject } from 'rxjs';
import { HubConnection } from '@microsoft/signalr';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class SignalRService extends BaseService {

  public hubConnection: signalR.HubConnection;
  //public bioTimeHubConnection: signalR.HubConnection;
  private SignalRUrl: string;
  //private BioTimeSignalRUrl: string;
  private BranchId: number;
  public SignalRConnectionStartedSubject = new Subject<HubConnection>();
  //public BioTimeSignalRConnectionStartedSubject = new Subject<HubConnection>();

  constructor(
    private _sharedService: SharedService,
    private _httpClient: HttpClient
  ) {
    super();

    //this.BioTimeSignalRUrl =  this._sharedService.BioTimeSignalRUrl+ MagicStrings.SignalRMapHubSecondSection;
    this.SignalRUrl = environment.SignalRUrl + MagicStrings.SignalRMapHubSecondSection;
    this.BranchId = this._sharedService.AccountSetupId;

  }

  private hubOptions: signalR.IHttpConnectionOptions = {
    withCredentials: true,
    accessTokenFactory: async () => {
      return (await this._sharedService.Token).replace('Bearer ', '');
    }
  };

  private options = {
    withCredentials: true,
    transport: signalR.HttpTransportType.WebSockets,
    logging: signalR.LogLevel.Trace,
    accessToken: function () {
      return this._sharedService.Token;
    }
  };


  public StartSignalRConnection = (): void => {

    this.hubConnection = new signalR.HubConnectionBuilder()
      .configureLogging(signalR.LogLevel.Information)
      .withUrl(this.SignalRUrl, this.hubOptions)
      .withAutomaticReconnect()
      .build();
    this.hubConnection.start().then(() => {

      var hubConnectionState = this.hubConnection.state;
      this.SignalRConnectionStartedSubject
        .next(this.hubConnection);

    }).catch(err => {

      console.log(err);

    });
    /*
        this.hubConnection = new signalR.HubConnectionBuilder()
          .withUrl(this.SignalRUrl)
          .build();
        this.hubConnection.start().then(() => {

          var hubConnectionState = this.hubConnection.state;
          this.SignalRConnectionStartedSubject
            .next(this.hubConnection);

        }).catch(err => {

          console.log(err);

        }); */

  }

  public joinGroup = (groupName: string): void => {
    this.hubConnection.invoke(MagicStrings.JoinGroup, [groupName], this._sharedService.AccountSetupId, this._sharedService.UserId)
      .then((y) => {
        console.log('Signal R joined signal r group:' +
          groupName);
      })
      .catch(err => console.log('Error while joining signal r group: ' + groupName + ' - ' + err));
      
  }

  public JoinCompanyGroup = () => {
    var groupName = MagicStrings.SignalRGroupNameFirstSectionCompany
      + this._sharedService.CompanyId;

    this.joinGroup(groupName);


    return this.hubConnection;
  }

  public JoinUserGroup = () => {

    var groupName = MagicStrings.SignalRGroupNameFirstSectionUser
      + this._sharedService.UserId;

    this.joinGroup(groupName);

    return this.hubConnection;
  }

  public JoinBranchGroup = () => {

    var groupName = MagicStrings.SignalRGroupNameFirstSectionBranch +
      this.BranchId;

    this.joinGroup(groupName);

    return this.hubConnection;
  }

  public JoinCashierGroup = (RequestPermissionNotificationId: number) => {

    var groupName = MagicStrings.SignalRGroupNameFirstSectionForUserThatReceiveAcceptOrReject
      + this.BranchId + MagicStrings.SignalRGroupNameRequestPermissionNotificationId +
      RequestPermissionNotificationId;


    this.joinGroup(groupName);

    return this.hubConnection;
  }

  public JoinAttendGymViaFingerprintGroup = () => {

    var groupName = MagicStrings.SignalRGroupNameFirstSectionEmployee
      + this._sharedService.EmployeeId + '-' + this._sharedService.AccountSetupId;

    this.joinGroup(groupName);

    return this.hubConnection;
  }

  public StopSignalRConnection = () => {

    if (this.hubConnection) {
      this.hubConnection.stop()
        .then(() => console.log('Signal R connection stoped'))
        .catch(err => console.log('Error while stoping signal r connection: ' + err));
    }

  }

  public LeaveBranchGroup = () => {

    var branchGroupName = MagicStrings.SignalRGroupNameFirstSectionBranch +
      this.BranchId;

    this.LeaveGroup(branchGroupName);
  }

  public LeaveGroup = (groupName: string) => {


    this.hubConnection.invoke(
      MagicStrings.LeaveGroup, groupName)
      .then(() => {

        console.log('Signal R leave group :' +
          groupName);
      })
      .catch(err => console.log('Error while leaveing signal r group: '
        + groupName + ' - ' + err))

    return this.hubConnection;
  }

}

